import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs';

@Injectable()
export class CustomTitleResolver extends TitleStrategy {
  private readonly translateService = inject(TranslateService);
  private readonly title = inject(Title);

  public override updateTitle(snapshot: RouterStateSnapshot): void {
    const titleKey = this.buildTitle(snapshot);

    if (!titleKey) {
      return;
    }

    // only first is enough, as we reload the app on language change
    this.translateService.onLangChange.pipe(first()).subscribe(() => {
      this.title.setTitle(this.translateService.instant(titleKey));
    });

    this.title.setTitle(this.translateService.instant(titleKey));
  }
}
